export default function contains(iterable, item) {
    for (const v of iterable) {
        if (v === item) {
            return true;
        }
    }
    return false;
}
